import { defineComponent as _defineComponent } from 'vue'
export type C4EIconType = 'c4e-circle' | 'c4e-circle-no-dots' | 'c4e-4-only' | 'c4e-green';

export default /*#__PURE__*/_defineComponent({
  __name: 'C4EIcon',
  props: {
    icon: { type: String, required: true },
    size: { type: [String, Number], required: true }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;


const __returned__ = { props }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})